import React from 'react';
import { Box, IconButton } from '@mui/material';
import { IconX } from '@tabler/icons';
import FIVBLogo from 'assets/images/icons/fivb-logo-sidemenu.svg';
import MenuList from '../Sidebar/components/MenuList/MenuList';
import ProfileSection from '../ProfileSection/ProfileSection';
import { Divider } from '@mui/material';
import 'assets/styles.css';

const MobileSidebar = ({ isOpen, onClose, menuItems }) => {
  if (!isOpen) return null;

  return (
    <Box className="MobileSidebar">
      {/* Top Box */}
      <Box className="MobileSidebarTopBox">
        {/* FIVB Logo */}
        <img
          src={FIVBLogo}
          alt="FIVB Logo"
          className="MobileSidebarLogo"
        />

        {/* Close Icon */}
        <IconButton
          onClick={onClose}
          className="MobileSidebarCloseButton"
        >
          <IconX className="MobileSidebarCloseIcon" />
        </IconButton>
      </Box>

      {/* Bottom Box */}
      <Box className="MobileSidebarBottomBox">
        <MenuList isMobile={true} menuItems={menuItems} />
        <Divider
          sx={{
            mt: 0.25,
            mb: 1.25,
            color: "var(--custom-accent-7, #E3E7E9)",
          }}
        />
        <ProfileSection isMobile={true} />
      </Box>
    </Box>
  );
};

export default MobileSidebar;
